export default {
  filterData : {
    Products: {
      label: 'Prodotti',
      allFilterLabel: "Tutti i prodotti",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Argomenti",
      allFilterLabel: "Tutti gli argomenti",
      items: [
        { name: "Gestione dell’accesso", id: "Access management" },
        { name: "Analytics e monitoraggio", id: "Analytics and monitoring" },
        { name: "Soluzioni di sicurezza e distribuzione delle applicazioni", id: "Application delivery and security" },
        { name: "Citrix e Google", id: "Citrix and Google" },
        { name: "Citrix e Microsoft", id: "Citrix and Microsoft" },
        { name: "Migrazione sul cloud", id: "Cloud migration" },
        { name: "Confrontate", id: "Compare" },
        { name: "Content collaboration", id: "Content collaboration" },
        { name: "Workspace digitali", id: "Digital workspaces" },
        { name: "Esperienza dei dipendenti", id: "Employee experience" },
        { name: "Cloud ibrido", id: "Hybrid cloud" },
        { name: "Lavoro ibrido", id: "Hybrid work" },
        { name: "Gestione e ottimizzazione", id: "Manage and optimize" },
        { name: "Microservizi e DevOps", id: "Microservices and devOps" },
        { name: "Adozione e onboarding", id: "Onboarding and adoption" },
        { name: "Integrazioni con i partner", id: "Partner integrations" },
        { name: "Panoramica del prodotto", id: "Product overview" },
        { name: "Sicurezza e conformità", id: "Security and compliance" },
        { name: "Piccole imprese", id: "Small business" },
        { name: "Specifiche", id: "Specifications" },
        { name: "Sostenibilità", id: "Sustainability" },
        { name: "Unified endpoint management", id: "Unified endpoint management" },
        { name: "VDI e DaaS", id: "VDI and DaaS" },
      ],
    }, 
   
    Type: {
      label: 'Tipo',
      allFilterLabel: "Tutti i tipi",
      items: [
        { name: "Report degli analisti", id: "Analyst report" },
        { name: "Strumento di assessment", id: "Assessment tool" },
        { name: "Testimonianza di un cliente", id: "Customer story" },
        { name: "Scheda tecnica", id: "Data sheet" },
        { name: "Demo", id: "Demo" },
        { name: "eBook", id: "eBook" },
        { name: "Guida", id: "Guide" },
        { name: "Infografica", id: "Infographic" },
        { name: "Tour interattivo", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Kit di risorse", id: "Resource kit" },
        { name: "Panoramica della soluzione", id: "Solution brief" },
        { name: "Technical briefing", id: "Technical brief" },
        { name: "Video", id: "Video" },
        { name: "Webinar", id: "Webinar" },
        { name: "White paper", id: "White paper" },
      ],
    },
    Industry: {
      label: "Settore",
      allFilterLabel: "Tutti i settori",
      items: [
        { name: "Istruzione", id: "education" },
        { name: "Servizi finanziari", id: "financial_service" },
        { name: "Pubblica Amministrazione", id: "government" },
        { name: "Sanità", id: "healthcare" },
        { name: "Manifatturiero", id: "manufacturing" },
        { name: "Settore commerciale", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Cerca nella risorse",
    titles : {
      label1: "I trend del momento",
      label2: "Risorse più recenti",
      label3: "Visti di recente",
      label4: "Risorse consigliate"
    },
    showMoreLabel: "Mostra altri",
    clearAllSelected: "Cancella tutti i selezionati",
    searchResults: "Cerca risultati per",
    clearAllFilters: "Cancella tutti i filtri",
    noResultsFound: "Nessun contenuto soddisfa i criteri selezionati",
    resetView: "Reimposta la visuale",
    filterLabel: "Filtra",
    filteredRes: "Risultati in base al filtro",
    filterRes: "Filtra i risultati",
    clearAllCta: "Cancella tutto",
    applyCta: "Applica",
    view: "Visualizza",
    includeEnglishRes: "Include risorse in lingua inglese"
  };
  